<template>
  <b-modal
    v-model="modalOpen"
    centered
    title="معلومات العضو"
    footer-class="removed"
    class="edit-modal"
    id="branchModal"
    no-close-on-backdrop
  >
    <b-card-text>
      <validation-observer ref="branchValidation">
        <b-form @submit.prevent>
          <b-row>
            <b-col cols="12">
              <form-input
                rules="required"
                label="الاسم الكامل"
                v-model="form.full_name"
              />
            </b-col>
            <b-col cols="12">
              <validation-provider
                #default="{ errors }"
                name="الرقم الوطني"
               
                mode="passive"
              >
                <b-form-group label="الرقم الوطني" label-for="id-num">
                  <cleave
                    id="id-num"
                    v-model="form.id_number"
                    class="form-control"
                    :class="{ 'cleave-error': errors.length > 0 }"
                    :raw="false"
                    :options="{
                      blocks: [11],
                      numericOnly: true,
                      delimiter: '',
                    }"
                  />
                  <small class="text-danger">{{
                    errors[0] ? "الرقم الوطني مطلوب" : ""
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12">
              <validation-provider
                #default="{ errors }"
                name="رقم الهاتف"
                rules="min:10"
                mode="passive"
              >
                <b-form-group label="رقم الهاتف" label-for="id-num">
                  <cleave
                    id="phone-num"
                    v-model="form.phone_number"
                    class="form-control"
                    :class="{ 'cleave-error': errors.length > 0 }"
                    :raw="false"
                    :options="{
                      blocks: [10],
                      numericOnly: true,
                    }"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <!-- <b-col cols="12">
              <form-input
                rules="required|integer|min:10"
                label="رقم الهاتف"
                v-model="form.phone_number"
              />
            </b-col> -->
            <b-col cols="12">
              <form-input
                rules="required"
                label="العنوان"
                v-model="form.address"
              />
            </b-col>
            <b-col cols="12">
              <form-mask
                options="date"
                placeholder="YYYY-MM-DD"
                id="infoModal_birthday"
                v-model="form.dob"
                label="تاريخ الميلاد"
                rules="required"
              />
            </b-col>

            <!-- <b-col cols="12">
              <form-textarea
                id="work"
                rules="required"
                label="العمل"
                v-model="form.jobs"
              />
            </b-col> -->
            <b-col cols="12" v-if="ngoId">
              <form-select
                v-if="action === 'C'"
                rules="required"
                label="الصفة"
                id="job_title_id"
                v-model="form.job_title_id"
                :reduce="(x) => x.id"
                :getOptionLabel="(x) => x.name"
                :ep="`v2/establishment/selects/job-title-by-director-boards/${ngoId}?fromEstablishment=true&slug=${action}`"
                
              />
              <form-select
                v-else
                rules="required"
                label="الصفة"
                id="job_title_id"
                v-model="form.job_title_id"
                :reduce="(x) => x.id"
                :getOptionLabel="(x) => x.name"
                :ep="`v2/establishment/selects/job-title-by-director-boards/${ngoId}?fromEstablishment=true&slug=${action}&jobTitleId=${form.job_title_id}`"
                
              />
            </b-col>
            <b-col cols="12">
              <form-select
                label="المؤهلات العلمية"
                ep="v2/establishment/selects/qualifications"
                v-model="form.qualification_id"
                id="qualification"
                :reduce="(x) => x.id"
                :getOptionLabel="(x) => x.title"
              />
            </b-col>
            <b-col cols="12">
              <form-file-input
                placeholder="اختر ملفاً"
                id="document"
                label="نشرة الإستعلام"
                accept=".pdf"
                v-model="form.inquiry_bulletin_file"
                rules="required"
              />
            </b-col>
          </b-row>
          <hr />

          <b-row class="px-1 justify-content-end">
            <b-button @click="modalOpen = false" class="mx-1">إلغاء</b-button>
            <save-btn
              @click="onSubmit"
              variant="primary"
              :loading="loading"
              :label="btnLabel"
            >
            </save-btn>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card-text>
  </b-modal>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardText,
  BCardTitle,
  BModal,
  BFormGroup,
  BFormRadio,
  BForm,
  BFormTextarea,
  BButton,
} from "bootstrap-vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import FormFileInput from "@/components/FormFileInput.vue";
import formSelect from "@/components/form-select";
import formInput from "@/components/form-input";
import saveBtn from "@/components/loader-btn";
import formDatepicker from "@/components/form-datepicker";
import FormTextarea from "@/components/form-textarea";
import Cleave from "vue-cleave-component";
import FormMask from "@/components/form-mask";

const initForm = {
  full_name: "",
  id_number: "",
  phone_number: "",
  dob:"",
};
export default {
  components: {
    formInput,
    formSelect,
    BButton,
    formDatepicker,
    saveBtn,
    BRow,
    BCol,
    BCard,
    BCardText,
    BCardTitle,
    BModal,
    BFormGroup,
    BForm,
    BFormRadio,
    BFormTextarea,
    ValidationObserver,
    ValidationProvider,
    FormTextarea,
    Cleave,
    FormMask,
    FormFileInput
  },
  props: {
    value: Boolean,
    title: String,
    btnLabel: String,
    ngoId:Number ,
    action: String,
    loading: Boolean,
    intializeForm: {
      type: Object,
      default: () => initForm,
    },
  },
  data() {
    return {
      form: {},
    };
  },
  computed: {
    modalOpen: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
  },
  watch: {
    modalOpen(val) {
      if (val) this.init(this.intializeForm);
    },
  },

  methods: {
    init(form) {
      this.form = JSON.parse(JSON.stringify(form));
    },

    async onSubmit() {
      await this.$refs.branchValidation.validate().then(async (success) => {
        if (success) {
          this.$emit("confirm", this.form);
        }
      });
    },
  },
};
</script>
